interface DatePickerFieldProps {
  label: string;
  value: Date | null;
  onChange: (date: Date | null) => void;
  required?: boolean;
  showTime?: boolean;
}

export function DatePickerField({
  label,
  value,
  onChange,
  required = false,
  showTime = true,
}: DatePickerFieldProps) {
  const pad = (n: number) => String(n).padStart(2, "0");

  const dateStr = value
    ? `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`
    : "";

  const timeStr = value
    ? `${pad(value.getHours())}:${pad(value.getMinutes())}`
    : "";

  function handleDateChange(e: React.ChangeEvent<HTMLInputElement>) {
    const val = e.target.value;
    if (!val) {
      onChange(null);
      return;
    }
    const [y, m, d] = val.split("-").map(Number);
    const prev = value || new Date();
    onChange(new Date(y, m - 1, d, prev.getHours(), prev.getMinutes()));
  }

  function handleTimeChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (!value) return;
    const val = e.target.value;
    if (!val) return;
    const [h, min] = val.split(":").map(Number);
    const d = new Date(value);
    d.setHours(h, min);
    onChange(d);
  }

  const inputClass =
    "h-9 w-full rounded-lg border border-border bg-secondary px-3 text-sm text-foreground focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent";

  return (
    <div>
      <label className="mb-1.5 block text-sm font-medium text-foreground">
        {label}{required && " *"}
      </label>
      {showTime ? (
        <div className="grid grid-cols-[1fr_100px] gap-2">
          <input type="date" value={dateStr} onChange={handleDateChange} required={required} className={inputClass} />
          <input type="time" value={timeStr} onChange={handleTimeChange} className={inputClass} placeholder="Saat" />
        </div>
      ) : (
        <input type="date" value={dateStr} onChange={handleDateChange} required={required} className={inputClass} />
      )}
    </div>
  );
}
